import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'



// firebase init
const firebaseConfig = {
    apiKey: "AIzaSyDVnxcpbrHwommcvU-wtomJPgNVIpmCE9M",
    authDomain: "dominosmundial.firebaseapp.com",
    projectId: "dominosmundial",
    storageBucket: "dominosmundial.firebasestorage.app",
    messagingSenderId: "1018875616449",
    appId: "1:1018875616449:web:e30da2310f8e6565ac4840"
};
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()
const functions = firebase.functions()

// collection references
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')
const ticketsCollection = db.collection('tickets')

// export utils/refs
export {
    db,
    auth,
    storage,
    functions,
    usersCollection,
    postsCollection,
    commentsCollection,
    likesCollection,
    ticketsCollection
}